<script setup lang="ts">

import { reactive, watch, onMounted } from 'vue';
import * as service from "@/services/ParametrosBoleto";

const emit = defineEmits(['change', "update:modelValue",])

interface iProps {
    modelValue?: any,
    disabled?: boolean,
    comIndefinido?: boolean
}

var props = defineProps<iProps>();

var controle = reactive({
    valor: props.modelValue,
    comIndefinido: props.comIndefinido,
    disabled: props.disabled,
    itens:[] as service.IParamBoleto[],
    opcoes: {} as service.IEnums
})

onMounted(async () => {
    buscar();
    controle.valor = props.modelValue != null ? props.modelValue : undefined;
})

watch(() => props.modelValue, async (novo: any) => {
    controle.valor = novo;
})


watch(() => props.disabled, async (novo: any) => {
    controle.disabled = novo;
})

const onChange = ()=> {
    emit("update:modelValue", controle.valor);
    emit("change", controle.valor);
}

function buscar() {
    service.obter().then((r) => {
        if (r != null) {
            controle.itens = r.dados;
        }
    })

    service.obterOpcoes().then((r) => {
        if (r != null) {
            controle.opcoes = r;
        }
    })  
}


</script>

<template>
    <select class="form-select form-select-sm" v-model="controle.valor" :disabled="controle.disabled" v-bind="$attrs" @change="onChange"> 
        <option :value="undefined" v-if="controle.comIndefinido == true">- Selecione -</option>
        <option v-for="(item,idx) in controle.itens" :key="idx" :value="item.paramBoletoId"> 
            {{ controle.opcoes.tipoCobranca?.find(a=> a.posicao == item.tipoCobranca)?.texto }}, 
            Agencia: {{ item.cedenteAgencia }}-{{ item.cedenteAgenciaDigito }}, 
            Conta: {{ item.cedenteConta }}-{{ item.cedenteContaDigito }},
            Código: {{ item.cedenteCodigo }}
        </option>
    </select>
</template>

<style scoped>

</style>